import { HttpParams } from '@angular/common/http';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
    ConfirmDialogInput,
    ConfirmDialogResult,
} from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import {
    ArrayTableColumn,
    PdfTableColumn,
    TableColumn,
    URLTableColumn,
} from '../../../components/kiene-table/table-column';
import { TableDescriptor } from '../../../components/kiene-table/table-descriptor';
import { Condition, Operator, TableOption } from '../../../components/kiene-table/table-option';
import { TabinfoService } from '../../../components/tabinfo/tabinfo.service';
import { ConfirmDeleteDialogComponent } from '../../../dialogs/confirm-delete-dialog/confirm-delete-dialog.component';

import { FileUploadService } from '../../../dialogs/file-upload-dialog/file-upload.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Fortbildung } from '../fortbildung';
import { FortbildungDialogComponent } from '../fortbildung-dialog/fortbildung-dialog.component';
import { TeilnehmerHinzufuegenDialogComponent } from '../teilnehmer-hinzufuegen-dialog/teilnehmer-hinzufuegen-dialog.component';

@Component({
    selector: 'kiene-fortbildung',
    templateUrl: './fortbildung.component.html',
    styleUrls: ['./fortbildung.component.css'],
})
export class FortbildungComponent implements OnInit {
    tableDescriptor: TableDescriptor = new TableDescriptor();

    @Input('tierarztId') tierarztId = 0;

    constructor(
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        public dialog: MatDialog,
        private messageService: MessageService,
        private localStorageService: LocalStorageService,
        private tableService: KieneTableService,
        private fileUploadService: FileUploadService,
        private pdfService: PdfViewerDesktopService,
        private tabinfoService: TabinfoService,
    ) {}

    ngOnInit() {
        this.tableDescriptor.headline = 'Fortbildungen';
        this.tableDescriptor.uniqueIdentifier = 'Fortbildungen';
        this.tableDescriptor.apiUrl = this.apiBaseUrl + 'fortbildung/';
        this.tableDescriptor.route = '/home?tab=fortbildung';
        this.tableDescriptor.nameOfIdField = 'fortbildung_id';
        this.tableDescriptor.searchPlaceholder = 'Fortbildungen durchsuchen';
        this.tableDescriptor.uniqueIdentifier = 'Fortbildungen';

        this.tableDescriptor.createAllowed = true;
        this.tableDescriptor.standardCreate = false;
        this.tableDescriptor.showDetails = false;

        const titelCol = new URLTableColumn('titel', 'Titel');
        titelCol.maxWidth = '350px';
        this.tableDescriptor.columns.push(titelCol);

        const veranstalterCol = new URLTableColumn('veranstalter', 'Veranstalter');
        veranstalterCol.maxWidth = '280px';
        this.tableDescriptor.columns.push(veranstalterCol);

        const ortCol = new URLTableColumn('veranstaltungsort', 'Veranstaltungsort');
        ortCol.maxWidth = '220px';
        this.tableDescriptor.columns.push(ortCol);

        this.tableDescriptor.columns.push(new TableColumn('datum', 'Datum', 'date', true, null, '120px'));
        this.tableDescriptor.columns.push(new TableColumn('anmeldefrist', 'Anmeldefrist', 'date', true, null, '120px'));
        this.tableDescriptor.columns.push(new TableColumn('teilnahme', 'Teilnahme', 'boolean', true, null, '90px'));

        const teilnehmerCol = new ArrayTableColumn('teilnehmer', 'Teilnehmer', ['teilnehmer']);
        teilnehmerCol.maxWidth = '200px';
        this.tableDescriptor.columns.push(teilnehmerCol);
        this.tableDescriptor.columns.push(new PdfTableColumn('pdf_id', 'PDF', this.showPdf.bind(this)));

        this.tableDescriptor.disableConditions.push(new Condition('abgelaufen', Operator.GLEICH, 1));

        this.tableDescriptor.expandable = true;
        this.tableDescriptor.expandableColumns = [new TableColumn('infotext', 'Infotext')];
        this.tableDescriptor.expandableFieldName = 'infotext_expand';

        this.tableDescriptor.permissionView = 4411;
        this.tableDescriptor.permissionCreate = 4412;

        this.tableDescriptor.initialSortColumn = 'datum';
        this.tableDescriptor.initialSortDirection = 'desc';
        this.tableDescriptor.addVoid = this.openFortbildungDialog.bind(this);

        this.tableDescriptor.options.push(
            new TableOption(this.openTeilnehmenDialog.bind(this), 'Teilnehmen', 'check_box', 4415, {
                conditions: [
                    new Condition('teilnahme', Operator.GLEICH, 0),
                    new Condition('abgelaufen', Operator.GLEICH, 0),
                ],
            }),
        );
        this.tableDescriptor.options.push(
            new TableOption(this.openTeilnehmenDialog.bind(this), 'Abmelden', 'check_box_outline_blank', 4415, {
                conditions: [
                    new Condition('teilnahme', Operator.GLEICH, 1),
                    new Condition('abgelaufen', Operator.GLEICH, 0),
                ],
            }),
        );
        if (this.localStorageService.isCurrentUserVerwaltung()) {
            this.tableDescriptor.options.push(
                new TableOption(
                    this.openTeilnehmerHinzufuegenDialog.bind(this),
                    'Andere Teilnehmer hinzufügen',
                    'person_add',
                    4415,
                ),
            );
        }
        this.tableDescriptor.options.push(
            new TableOption(this.openFortbildungDialog.bind(this), 'Bearbeiten', 'edit', 4412, {
                conditions: [new Condition('abgelaufen', Operator.GLEICH, 0)],
            }),
        );
        this.tableDescriptor.options.push(new TableOption(this.upload.bind(this), 'PDF hochladen', 'upload', 4412));
        this.tableDescriptor.options.push(
            new TableOption(this.openDeleteDialog.bind(this), 'Löschen', 'delete', 4414, {
                conditions: [new Condition('abgelaufen', Operator.GLEICH, 0)],
            }),
        );

        this.tableService.watchDataLoadedCompleted().subscribe({
            next: n => {
                if (n) {
                    this.fortbildungenGeladen();
                }
            },
        });
    }

    fortbildungenGeladen() {
        this.tableService.post(this.apiBaseUrl + 'fortbildung/gesehen.php', {}, null).subscribe({
            next: () => {
                this.tabinfoService.setReload('fortbildung/tabinfo.php');
            },
            error: err => {
                this.messageService.errorMessage('Fortbildungen konnten nicht als gelesen markiert werden!', err);
            },
        });
    }

    showPdf(fortbildung: Fortbildung) {
        const input = new PdfViewerDialogInput(
            'fortbildung/read_pdf.php',
            new HttpParams().set('fortbildung_id', fortbildung?.fortbildung_id),
            'Fortbildung PDF',
        );
        this.pdfService.openPdfViewer(input);
    }

    upload(fortbildung: Fortbildung) {
        this.fileUploadService.openAddFilesDialog(
            fortbildung.fortbildung_id,
            'fortbildung_id',
            'fortbildung/update_pdf.php',
            () => {
                this.messageService.infoMessage('Die Datei wurde erfolgreich hochgeladen!');
                this.tableService.reload();
            },
            () => {},
        );
    }

    openFortbildungDialog(fortbildung?: Fortbildung) {
        const dialogRef = this.dialog.open(FortbildungDialogComponent, { data: { fortbildung: fortbildung } });
        dialogRef.afterClosed().subscribe(() => {
            this.tableService.reload();
        });
    }

    openTeilnehmenDialog(fortbildung: Fortbildung) {
        const notRegistered = Number(fortbildung.teilnahme) === 0;
        const input = new ConfirmDialogInput();
        input.headline = notRegistered ? 'Teilnahme' : 'Abmelden';
        input.text = notRegistered
            ? 'Wollen Sie an dieser Fortbildung teilnehmen?'
            : 'Wollen Sie sich von dieser Fortbildung abmelden?';
        input.okButton = notRegistered ? 'Teilnehmen' : 'Abmelden';

        const dialogRef = this.dialog.open(ConfirmDialogComponent, { data: input });

        dialogRef.afterClosed().subscribe({
            next: (result: ConfirmDialogResult) => {
                if (result?.confirmed) {
                    const teilnahme = {
                        fortbildung_id: fortbildung.fortbildung_id,
                        teilnehmen: notRegistered ? 1 : 0,
                    };
                    this.tableService.post(this.apiBaseUrl + 'fortbildung/teilnehmen.php', teilnahme, null).subscribe(
                        () => {
                            if (teilnahme.teilnehmen === 1) {
                                this.messageService.infoMessage(
                                    'Sie haben sich erfolgreich für die Fortbildung angemeldet!',
                                );
                            } else {
                                this.messageService.infoMessage(
                                    'Sie haben sich erfolgreich von der Fortbildung abgemeldet!',
                                );
                            }
                            this.tableService.reload();
                        },
                        error => {
                            this.messageService.errorMessage('Fehler beim Speichern aufgetreten!', error);
                            this.tableService.reload();
                        },
                    );
                }
            },
        });
    }

    openDeleteDialog(fortbildung: Fortbildung) {
        const dialogRef = this.dialog.open(ConfirmDeleteDialogComponent);
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.tableService.deleteEntity(this.apiBaseUrl + 'fortbildung/delete.php', fortbildung).subscribe(
                    () => {
                        this.messageService.infoMessage('Die Fortbildung wurde erfolgreich gelöscht!');
                        this.tableService.reload();
                    },
                    error => {
                        this.messageService.errorMessage('Fehler beim Löschen aufgetreten!', error);
                    },
                );
            }
        });
    }

    private openTeilnehmerHinzufuegenDialog(fortbildung: Fortbildung): void {
        console.log('open', fortbildung);
        this.dialog
            .open(TeilnehmerHinzufuegenDialogComponent, { data: { fortbildung: fortbildung }, width: '500px' })
            .afterClosed()
            .subscribe({
                next: result => {
                    console.log('result', result);
                    if (result) {
                        this.tableService.reload();
                    }
                },
            });
    }
}
